import styled from "styled-components";

export const CurrentBMIStatContainerStyled = styled.div`
  .loading_layout {
    height: calc(100vh - 186px);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .section_introduce_layout {
    margin-bottom: 22px;
  }
  .section_graph {
    margin-bottom: 14px;
  }
  .block_2_col_layout {
    display: flex;
    padding: 10px 0px 10px 5px;
    column-gap: 16px;
    row-gap: 16px;
    margin: 0 -5px;
    overflow: auto;
    height: 523px;
    overflow-y: hidden;
    ::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }
    ::-webkit-scrollbar-button {
      width: 0px;
      height: 0px;
    }
    ::-webkit-scrollbar-thumb {
      background: #cccccc;
      border: 0px none #ffffff;
      border-radius: 50px;
    }
    ::-webkit-scrollbar-thumb:hover {
      background: #cccccc;
    }
    ::-webkit-scrollbar-thumb:active {
      background: #c2c2c2;
    }
    ::-webkit-scrollbar-track {
      background: #ebebeb;
      border: 0px none #ffffff;
      border-radius: 50px;
    }
    ::-webkit-scrollbar-track:hover {
      background: #e6e6e6;
    }
    ::-webkit-scrollbar-track:active {
      background: #ebebeb;
    }
    ::-webkit-scrollbar-corner {
      background: transparent;
    }
    .col_2 {
      &.flex_1 {
        flex: 1;
      }
      &.w_340 {
        flex-shrink: 0;
        width: 365px;
      }
      &.mw_700 {
        min-width: 800px;
      }
      .wrap_mr5_overflow {
        margin-right: 5px;
      }
    }
  }
  .bmiDep {
    margin-top: 14px;
  }
  .export {
    margin-top: 24px;
  }
`;
